import _forEach from 'lodash/forEach';
import { sagaMiddleware } from 'app/store';
import uiSagas from 'app/common/domains/ui/ui-sagas';
import submissionsSagas from 'app/queue/domains/submissions/submissions-sagas';
import plagiarismCaseQueueSagas from 'app/queue/domains/plagiarism-case-queue/plagiarism-case-queue-sagas';
import questionQueueSagas from 'app/queue/domains/question-queue/question-queue-sagas';
import reviewsQueueSagas from 'app/queue/domains/reviews-queue/reviews-queue-sagas';

const sagas = {
  uiSagas,
  submissionsSagas,
  plagiarismCaseQueueSagas,
  questionQueueSagas,
  reviewsQueueSagas,
};

export default function initalizeRootSaga() {
  _forEach(sagas, (moduleRoot) => {
    sagaMiddleware.run(moduleRoot);
  });
}
